import { Component, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { LeitsetlleEdit } from "../../Controlls/EditViews/LeitsetlleEdit";
import { PopUpView } from "../../../Componente/PopUpView";
import { Grund, Leitstelle } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { GrundEdit } from "../../Controlls/EditViews/GrundEdit";


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, GrundEdit, PopUpView
  ],
  selector: 'Gruende',
  templateUrl: './Gruende.html',
  standalone: true,
  styleUrl: './Gruende.css'
})
export class GruendeList {
  @ViewChild('Grid') childComponent!: DataGridView<Grund>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
